import { useQuery } from '@tanstack/react-query';

import getReportAttendanceHostStatus from 'Api/report-attendance-host-detail/getAttendanceHostStatus,';

import getAttendanceHostStatusResponse from './model/response/getAttendanceHostStatusResponse';

const useGetAttendanceHostStatus = () => {
  return useQuery({
    queryKey: ['attendance-host-status'],
    queryFn: async () => {
      const response = await getReportAttendanceHostStatus();

      return getAttendanceHostStatusResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetAttendanceHostStatus;
